import { render, staticRenderFns } from "./UploadOnboardingDocuments.vue?vue&type=template&id=43247894"
import script from "./UploadOnboardingDocuments.vue?vue&type=script&lang=js"
export * from "./UploadOnboardingDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports